import type React from 'react';
import styled from 'styled-components';

export type SelectValue = string | number;
export type SelectDropdownProps = {
  readonly onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  readonly options: Array<{ value: SelectValue; label: string }>;
  readonly selected?: SelectValue;
};

const Dropdown = styled('select')(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: '1rem',
  background: 'none',
  outline: 'none',
  border: 'none',
  cursor: 'pointer'
}));

const SelectDropdown: React.FC<SelectDropdownProps> = (props: SelectDropdownProps) => {
  const { options, selected, onChange } = props;
  return (
    <Dropdown value={selected} onChange={onChange}>
      {options.map(({ label, value }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </Dropdown>
  );
};

export default SelectDropdown;
